import { s } from "@kosmod/pancake";
import * as three from 'three';

import { renderBeat, useDisposable } from "@kosmod/graphics-3d";
import { h, useRef } from "@lukekaalim/act";
import { useJeffect } from "@kosmod/kit";
import { a3 } from "@lukekaalim/act-three";
import { html } from "@lukekaalim/act-web";
import { assetsURLs } from "../../assets";

import { defineToolHandler } from "./handler";
import { TheatrePosition, tools } from "../../defs";
import { SlotStateIcon } from "./ToolSlotRenderer";
import { SELECTION_FILTER } from "../../defs/tools/selection";

const ICONS_FOR_FILTER: { [Key in SELECTION_FILTER]: string } = {
  'die': assetsURLs.icons.dice,
  'mini': assetsURLs.icons.mini,
  'surface': assetsURLs.icons.surface,
  'terrain': assetsURLs.icons.terrain_brush,
} 

defineToolHandler(tools.selection.select, {
  def: tools.selection.select,
  onInput(event, state, theatre) {
    if (event.type === 'mouse' && event.button === 'primary') {
      const position = theatre.cursorPosition.get();
      if (position) {
        const gridPosition = TheatrePosition.snapToSquareGrid(position);
        const mini = theatre.data.minis.find(mini => {
          return TheatrePosition.equal(mini.current.position, gridPosition);
        })
        if (mini) {
          theatre.selection.select({ type: 'mini', miniId: mini.current.id });
        } else {
          theatre.selection.select({ type: 'none' });
        }
      }
    }
  },
  onUpdate(state, theatre) {
    const position = theatre.cursorPosition.get();
    if (position) {
      const gridPosition = TheatrePosition.snapToSquareGrid(position);
      const mini = theatre.data.minis.find(mini => {
        return TheatrePosition.equal(mini.current.position, gridPosition);
      })
      if (mini) {
        if ((theatre.selection.hover.type !== 'mini' || theatre.selection.hover.miniId !== mini.current.id))
          theatre.selection.setHoverTarget({ type: 'mini', miniId: mini.current.id });
      } else if (theatre.selection.hover.type !== 'none') {
        theatre.selection.setHoverTarget({ type: 'none' });
      }
    }
  },
  PreviewComponent({ cursorPosition, material }) {
    const onRender = renderBeat.useBeat();
    const ref = useRef<null | three.Object3D>(null);

    useJeffect(j => {
      const mesh = ref.get()!;
      j.add(onRender(() => {
        const position = cursorPosition.get();
        if (position) {
          mesh.visible = true;
          const gridPosition = TheatrePosition.snapToSquareGrid(position);
          mesh.position
            .copy({ x: gridPosition.vector.x, y: 0, z: gridPosition.vector.y })
            .add({ x: .5, y: 0, z: .5 });
        } else {
          mesh.visible = false;
        }
      }))
    }, [])
    const geometry = useDisposable(() => new three.BoxGeometry(1, 0.02, 1), [])

    return h(a3.mesh, { ref, geometry, material: material || undefined });
  },
  ToolbeltComponent({ toolState }) {
    return [
      h(SlotStateIcon, {}, [
        h(html.img, { src: ICONS_FOR_FILTER[toolState.filter] })
      ]),
      h(html.img, { src: assetsURLs.icons.select })
    ]
  }
});


defineToolHandler(tools.selection.deselect, {
  def: tools.selection.deselect,
  
  onSelect(state, tools, selection) {
    selection.select({ type: 'none' });
    return false;
  },
  ToolbeltComponent() {
    return h(html.img, { src: assetsURLs.icons.deselect })
  }
});
